import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: localStorage.getItem('logged') === null ? 'login' : 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'agenda-doctor',
    loadChildren: () => import('./agenda-doctor/agenda-doctor.module').then(m => m.AgendaDoctorPageModule)
  },
  {
    path: 'lista-agenda-doctor',
    loadChildren: () => import('./lista-agenda-doctor/lista-agenda-doctor.module').then(m => m.ListaAgendaDoctorPageModule)
  },
  {
    path: 'atencion-paciente',
    loadChildren: () => import('./atencion-paciente/atencion-paciente.module').then(m => m.AtencionPacientePageModule)
  },
  {
    path: 'buscador-citas',
    loadChildren: () => import('./buscador-citas/buscador-citas.module').then(m => m.BuscadorCitasPageModule)
  },
  {
    path: 'comprobante',
    loadChildren: () => import('./comprobante/comprobante.module').then(m => m.ComprobantePageModule)
  },
  {
    path: 'comprobante-unificado',
    loadChildren: () => import('./comprobante-unificado/comprobante-unificado.module').then(m => m.ComprobanteUnificadoPageModule)
  },
  {
    path: 'nueva-receta',
    loadChildren: () => import('./nueva-receta/nueva-receta.module').then(m => m.NuevaRecetaPageModule)
  },
  {
    path: 'imprimir-receta',
    loadChildren: () => import('./imprimir-receta-lentes/imprimir-receta-lentes.module').then(m => m.ImprimirRecetaLentesPageModule)
  },
  {
    path: 'expediente-anterior',
    loadChildren: () => import('./expediente-anterior/expediente-anterior.module').then(m => m.ExpedienteAnteriorPageModule)
  },
  {
    path: 'imprimir-receta-lentes',
    loadChildren: () => import('./imprimir-receta-lentes/imprimir-receta-lentes.module').then(m => m.ImprimirRecetaLentesPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
